export default {
    GiveAwayAPI_URL: 'https://localhost:44396',
    Tools_Env: 'dev',
    SSO_CallbackUrl: "http://localhost:8080/login",
    CognitoCustomDomain: "https://wfiws-dev-ems.auth.eu-west-1.amazoncognito.com"
}